document.addEventListener("DOMContentLoaded", (event) => {
  const swatchItems = document.querySelectorAll('.default-swatch');
  swatchItems.forEach((swatch) => {
    if(window.innerWidth < 768) {
      const whatDevice2 = /iPad|iPhone|iPod/.test(navigator.userAgent);
      let whatEventUse2 = whatDevice2 ? 'touchend' : 'click';
      
      swatch.addEventListener(whatEventUse2, (event) => {
       const secondaryImage = document.querySelector(`[data-product-card='${event.currentTarget.dataset.productId}'] [data-variant-color='${event.currentTarget.title}']`);
        secondaryImage.style.visibility = 'visible';
        secondaryImage.classList.add('sm:transition-transform', 'sm:duration-300', 'sm:group-hover:scale-[103%]')
        const primaryImage = document.querySelector(`[data-product-card='${event.currentTarget.dataset.productId}'] .product-card__featured-image`);
        primaryImage.style.visibility = 'hidden';
        const primarySecondaryImage = document.querySelector(`[data-product-card='${event.currentTarget.dataset.productId}'] .product-card__secondary-image:not([data-variant-color])`);
        primarySecondaryImage.style.visibility = 'hidden'
      })

      const primarySwatches = document.querySelectorAll('.primary-default-swatch');
      primarySwatches.forEach((swatch) => {
        swatch.addEventListener(whatEventUse2, (event) => {
          const siblingSecondaryImages = document.querySelectorAll(`[data-product-card='${event.currentTarget.dataset.productId}'] [data-variant-color]`)
          siblingSecondaryImages.forEach((secondImg) => {
            secondImg.style.visibility = 'hidden';
          })
          const primaryImage = document.querySelector(`[data-product-card='${event.currentTarget.dataset.productId}'] .product-card__featured-image`);
          const primarySecondaryImage = document.querySelector(`[data-product-card='${event.currentTarget.dataset.productId}'] .product-card__secondary-image`);
          primaryImage.style.visibility = 'visible';
          primarySecondaryImage.style.visibility = 'visible';
        })
      })
      
    } else {
      swatch.addEventListener('mouseover', (event) => {
      const secondaryImage = document.querySelector(`[data-product-card='${event.currentTarget.dataset.productId}'] [data-variant-color='${event.currentTarget.title}']`);
      secondaryImage.style.visibility = 'visible';
      secondaryImage.classList.add('sm:transition-transform', 'sm:duration-300', 'sm:group-hover:scale-[103%]')
      const primaryImage = document.querySelector(`[data-product-card='${event.currentTarget.dataset.productId}'] .product-card__featured-image`);
      primaryImage.style.visibility = 'hidden';
      const primarySecondaryImage = document.querySelector(`[data-product-card='${event.currentTarget.dataset.productId}'] .product-card__secondary-image:not([data-variant-color])`);
      primarySecondaryImage.style.visibility = 'hidden';
    })
     swatch.addEventListener('mouseout', (event) => {
        const allSecondaryImage = document.querySelectorAll(`[data-product-card='${event.currentTarget.dataset.productId}'] .product-card__secondary-image:not([data-variant-color='${event.currentTarget.title}'])`)
        allSecondaryImage.forEach((secondImg) => {
          secondImg.style.visibility = 'hidden';
        })
      })
    }

     const primarySwatches = document.querySelectorAll('.primary-default-swatch');
    primarySwatches.forEach((swatch) => {
      swatch.addEventListener('mouseover', (event) => {
        const siblingSecondaryImages = document.querySelectorAll(`[data-product-card='${event.currentTarget.dataset.productId}'] [data-variant-color]`)
        siblingSecondaryImages.forEach((secondImg) => {
          secondImg.style.visibility = 'hidden';
        })
        const primaryImage = document.querySelector(`[data-product-card='${event.currentTarget.dataset.productId}'] .product-card__featured-image`);
        const primarySecondaryImage = document.querySelector(`[data-product-card='${event.currentTarget.dataset.productId}'] .product-card__secondary-image`);
        primaryImage.style.visibility = 'visible';
        primarySecondaryImage.style.visibility = 'visible';
      })
    })
  })
});



